import type { Node } from '@glueapp/graph-types';
type LibraryElementType = 'LIBRARY_NODE' | 'FUNCTION_INSTANCE' | 'NEW_FUNCTION' | 'AI_AGENT';

interface LibraryBaseElement {
    type: LibraryElementType;
    id: string;
    name: string;
    description: string;
    category: string;
    color: string;
    nodeId: string;
}

export interface LibraryNodeElement extends LibraryBaseElement {
    type: 'LIBRARY_NODE';
}

export interface NewFunctionLibraryElement extends LibraryBaseElement {
    type: 'NEW_FUNCTION';
}

export interface FunctionInstanceLibraryElement extends LibraryBaseElement {
    type: 'FUNCTION_INSTANCE';
    functionId: string;
}

export interface AIAgentLibraryElement extends LibraryBaseElement {
    type: 'AI_AGENT';
}

export type LibraryElement = LibraryNodeElement | NewFunctionLibraryElement | FunctionInstanceLibraryElement | AIAgentLibraryElement;

export function libraryNodeElementFromNode(node: Node): LibraryElement {
    return {
        type: 'LIBRARY_NODE',
        id: node.id,
        name: node.name,
        description: node.description,
        category: node.category,
        color: node.color,
        nodeId: node.id,
    };
}
